import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'
import { DEFAULT_THEME_PRESET } from '@/utils/themePalette'

Vue.use(Vuetify)
export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      dark: {
        // primary: "#607df9",
        // accent: "#607df9",
        accent: DEFAULT_THEME_PRESET.btnToggle,
        secondary: '#a73aeb',
        info: '#0164d3',
        warning: '#fec500',
        // error: "#ff4d7e",
        success: '#2cdd9b',
      },
      light: {
        // primary: "#607df9",
        // accent: "#607df9",
        secondary: '#a73aeb',
        info: '#0164d3',
        warning: '#fec500',
        // error: "#ff4d7e",
        success: '#2cdd9b',
        primary: DEFAULT_THEME_PRESET.primary,
        accent: DEFAULT_THEME_PRESET.btnToggle,
        titleBg1: DEFAULT_THEME_PRESET.titleBg1,
        titleBg2: DEFAULT_THEME_PRESET.titleBg2,
        chartColor: DEFAULT_THEME_PRESET.chartColor,
        chartBg: DEFAULT_THEME_PRESET.chartBg,
        titleText: DEFAULT_THEME_PRESET.titleText,
        textColorD: DEFAULT_THEME_PRESET.textColorD,
        sideBar: DEFAULT_THEME_PRESET.sideBar,
        btnToggle: DEFAULT_THEME_PRESET.btnToggle,
      },
    },
  },
})
